.statusBodyText {
    color: var(--mantine-color-white);
    --text-fz: var(--mantine-font-size-sm);
    --text-lh: var(--mantine-line-height-sm);
    line-height: 130%;
    text-align: center;
}

.statusBodyHeader {
    color: var(--mantine-color-white);
    --text-fz: var(--mantine-font-size-sm);
    --text-lh: var(--mantine-line-height-sm);
    line-height: 130%;
    font-size: var(--mantine-font-size-xl);
    text-align: center;
    margin-bottom: 12px;
}
